export function Container({
  children,
  fluid = false,
  padding = null,
  bg = "",
}) {
  return (
    <div
      className={`container${
        fluid ? "-fluid" : ""
      } p-${padding} bg-${bg} animate__animated animate__fadeIn`}
    >
      {children}
    </div>
  );
}
